import React, { HTMLProps, useMemo } from 'react';
import { toPercentage } from '../../../../utils/parsers';

export const FundCompareList: React.FC<
    {
        showColoredCircles?: boolean;
        sections?: {
            title?: string;
            items: { tint: string; id: string; name: string; weight: number }[];
        }[];
        appendix?: 'total' | 'remaining' | 'none';
    } & HTMLProps<HTMLDivElement>
> = ({ className, sections = [], appendix = 'none', showColoredCircles = true, ...rest }) => {
    const total = useMemo(() => {
        return (
            Math.floor(
                sections.reduce((total, section) => {
                    return (
                        total +
                        section.items.reduce((total, item) => {
                            if (item.name === 'Overig') return total;
                            return total + item.weight;
                        }, 0)
                    );
                }, 0) * 100,
            ) / 100
        );
    }, [sections]);

    const remaining = useMemo(() => {
        return 100 - Math.floor(total * 1000) / 1000;
    }, [total]);

    return (
        <div
            className={`grid gap-12 flex-1 ${className}`}
            style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))' }}
        >
            {sections.map(({ title, items }, index) => {
                const totalWeight = items.reduce((total, item) => {
                    return total + item.weight;
                }, 0);
                return (
                    <div className={`flex flex-col px-8`} key={index}>
                        {!!title && (
                            <div className="flex flex-row">
                                <div className="flex items-start justify-left">
                                    <div className="opacity-0 rounded-full w-4 h-4"></div>
                                </div>
                                <div className="ml-4 flex-1 font-medium text-lg">{title}</div>
                                <div className="ml-4 font-medium text-lg flex justify-end">
                                    {toPercentage(totalWeight)}
                                </div>
                            </div>
                        )}
                        {items.map(({ id, name, tint, weight }, fundIndex) => {
                            if (name === 'Overig') {
                                return undefined;
                            }
                            return (
                                <div
                                    key={name + weight || 0}
                                    className={`mt-4 flex flex-row ${weight === 0 ? 'opacity-40' : ''}`}
                                >
                                    {showColoredCircles && (
                                        <div className="flex items-center justify-end">
                                            <div
                                                className="rounded-full w-4 h-4"
                                                style={{ backgroundColor: tint }}
                                            ></div>
                                        </div>
                                    )}

                                    <div className={` ${showColoredCircles ? 'ml-4' : ''} flex-1`}>
                                        {name === 'Anders' ? 'Overig' : name}
                                    </div>
                                    <div className="ml-4 flex justify-end">{toPercentage(weight || 0)}</div>
                                </div>
                            );
                        })}
                        {(appendix === 'total' || appendix === 'remaining') && (
                            <div className={`mt-4 flex flex-row`}>
                                {showColoredCircles && (
                                    <div className="flex items-center justify-end">
                                        <div
                                            className="rounded-full w-4 h-4"
                                            style={{ backgroundColor: '#9CA3AF' }}
                                        ></div>
                                    </div>
                                )}
                                <div className={` ${showColoredCircles ? 'ml-4' : ''} flex-1`}>
                                    {appendix === 'total' ? 'Totaal' : 'Overig'}
                                </div>
                                <div className="ml-4 flex justify-end">
                                    {appendix === 'total' ? toPercentage(total) : toPercentage(remaining)}
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
